import { ScreenHeader } from '@/components/layout/screen-header';
import Constants from 'expo-constants';
import React from 'react';
import { Pressable, ScrollView, Text } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import {
  SettingsItemData,
  SettingsToggleItemData,
} from './components/settings-item';
import { SettingsSection } from './components/settings-section';

interface SettingsScreenProps {
  accountSettings: SettingsItemData[];
  preferencesSettings: SettingsToggleItemData[];
  supportSettings: SettingsItemData[];
  onSignOut?: () => void;
}

export function SettingsScreen({
  accountSettings,
  preferencesSettings,
  supportSettings,
  onSignOut,
}: SettingsScreenProps) {
  return (
    <SafeAreaView className="flex-1">
      <ScrollView
        className="flex-1"
        showsVerticalScrollIndicator={false}
        contentContainerClassName="px-4 pb-8"
      >
        <ScreenHeader title="Settings" showBackButton />

        {/* Settings Sections */}
        <SettingsSection title="Account" items={accountSettings} />
        <SettingsSection title="Preferences" items={preferencesSettings} />
        <SettingsSection title="Support" items={supportSettings} />

        {/* Sign Out Button */}
        {onSignOut && (
          <Pressable
            className="py-4 rounded-xl mt-4 bg-surface-secondary"
            onPress={onSignOut}
          >
            <Text className="text-center font-medium text-foreground">
              Sign Out
            </Text>
          </Pressable>
        )}

        {/* App Version */}
        <Text className="text-center text-xs mt-6 text-muted-foreground">
          Version {Constants.expoConfig?.version ?? '0.0.0'}
        </Text>
      </ScrollView>
    </SafeAreaView>
  );
}
